import { useCallback } from 'react';

import { useOpenNotification } from 'utils/antd/notification-toasts';
import { handleError, triggerDownload } from 'utils/download';

import { getDisbursementPayoutReportsUuidDownload } from 'api';

import { useOrganisationId } from 'hooks/context';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { DownloadPayoutRequestsDialog } from './DownloadPayoutRequestsDialog';
import { ExportedPayoutsHeader } from './ExportedPayoutsHeader';
import { ExportedPayoutsTable } from './ExportedPayoutsTable';
import type { FiltersState } from './localState';
import { useLocalState } from './localState';

export const ExportedPayouts = () => {
  const organisationId = useOrganisationId<number>();
  const openNotification = useOpenNotification();

  const {
    state: localState,
    dispatch,
    resetState,
    setFilters: updateFilters,
    updateCursorAfter
  } = useLocalState();

  const setFilters = (value: FiltersState) => {
    dispatch(updateFilters(value));
  };

  const downloadReport = useCallback(
    async (uuid: string) => {
      try {
        const data = await getDisbursementPayoutReportsUuidDownload(
          organisationId,
          uuid
        );
        triggerDownload(new Blob([data], { type: 'text/csv' }), 'report.csv');
      } catch {
        handleError(openNotification, 'Error while downloading the file');
      }
    },
    [organisationId, openNotification]
  );

  return (
    <>
      <TableLayout
        header={
          <ExportedPayoutsHeader
            filters={localState.filters}
            setFilters={setFilters}
            resetState={resetState}
          />
        }
        content={
          <ExportedPayoutsTable
            localState={localState}
            updateCursorAfter={updateCursorAfter}
            downloadReport={downloadReport}
          />
        }
      />
      <DownloadPayoutRequestsDialog downloadReport={downloadReport} />
    </>
  );
};
